import React from 'react'
import strings from 'mobile_web/strings'
import './styles.less'
import { Button } from '@mytours/components'

interface Props {
	onClick: React.MouseEventHandler<HTMLButtonElement>
	isFavourited: boolean
	favoritesEnabled?: boolean
}
export const ItemFavouriteButton: React.FC<Props> = ({ onClick, isFavourited, favoritesEnabled }) => {
	const icon = isFavourited ? 'fas fa-heart' : 'fal fa-heart'
	const label = isFavourited ? strings.unfavourite : strings.favourite
	if (!favoritesEnabled) {
		return null
	}
	return (
		<Button
			variant="clear"
			type="button"
			className="item-favourite-button-container"
			onClick={onClick}
			aria-label={label}
		>
			<i className={icon} aria-hidden="true" />
		</Button>
	)
}
